import { mediaQuery } from 'constants/ui';

import { MESSAGE_TOOLS_CLASS_NAME } from '../MessageTools/MessageTools.constants';

export const containerStyles = {
  display: 'flex',
  gap: '8px',
  flexDirection: 'row-reverse',
  maxWidth: '100%',
  [mediaQuery.mobile]: {
    gap: '6px',
  },
};

export const contentWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  [`&:hover .${MESSAGE_TOOLS_CLASS_NAME}`]: {
    opacity: 1,
    pointerEvents: 'auto',
  },
};

export const messageContentStyles = {
  padding: '8px 12px',
  borderRadius: '8px',
  wordBreak: 'break-word',
  backgroundColor: ({ palette }) => palette.background.disabled,
};

export const messageToolsHiddenStyles = {
  opacity: 0,
  pointerEvents: 'none',
  transition: 'opacity 0.2s ease-in-out',
};
